import React from 'react';

import { Subscriber } from '@atlaskit/rovo-triggers/main';

import { useChatContextStoreActions } from './store';

export const ChatContextSubscriber = (): React.JSX.Element => {
	const {
		setEditorContext,
		setBrowserContext,
		setDashboardContext,
		setAIFeatureContext,
		setJiraCreateContext,
		mergeDatabaseContext,
	} = useChatContextStoreActions();

	return (
		<Subscriber
			topic="ai-mate"
			onEvent={async (payload) => {
				// TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
				try {
					switch (payload.type) {
						case 'editor-context-payload':
							setEditorContext(payload.data);
							break;
						case 'browser-context-payload':
							setBrowserContext(payload.data);
							break;
						case 'dashboard-insights-actions':
							setDashboardContext(payload.data);
							break;
						case 'database-context-payload':
							mergeDatabaseContext(payload.data);
							break;
						case 'set-message-context': {
							setAIFeatureContext(payload.data);
							break;
						}
						case 'jira-create-context-payload': {
							setJiraCreateContext(payload.data);
							break;
						}
						default:
					}
				} catch {}
			}}
		/>
	);
};
